export const HeaderString = {
  About: "About",
  SignUp: "Sign-Up",
  Login: "Login",
  AddListing: "Add listing",
  Logout: "Logout",
  Contact: "Contact",
  List_With: "LIST WITH US TODAY!",
  Admin_Dashboard: "Admin Dashboard",
};

export const HomeString = {
  Home_Source: "YOUR SOURCE FOR",
  Used_Paving: "USED ASPHALT PAVING EQUIPMENT",
  SEARCH: "SEARCH",
  FEATURED_LISTINGS: "FEATURED LISTINGS",
  LATEST_LISTINGS: "LATEST LISTINGS",
  CATEGORIES: "CATEGORIES",
  Track_Pavers: `8’ Track Pavers`,
  E_Rubber_Tired_Pavers: `8’ Rubber Tired Pavers`,
  Track_Paver: `10’ Track Paver`,
  Rubber_Tired_Pavers: `10’ Rubber Tired Pavers`,
  Asphalt_Distributors: "Asphalt Distributors",
  Asphalt_Plants: "Asphalt Plants",
  Brooms: "Brooms",
  Chip_Spreaders: "Chip Spreaders",
  Compaction: "Compaction",
  Concrete: "Concrete",
  Crushers: "Crushers",
  Force_Feed_Loaders: "Force Feed Loaders",
  Milling_Machines: "Milling Machines",
  Material_Transfer_Vehicles: "Material Transfer Vehicles",
  Miscellaneous: "Miscellaneous",
  Reclaimers_Stabilizers: "Reclaimers & Stabilizers",
  Road_Wideners: "Road Wideners",
  Striping: "Striping",
  List_With_Us_Today: "List with us today!",
  Subheading: "Subheading",
  Body_Text:
    "Body text for your whole article or post. We’ll put in some lorem ipsum to show how a filled-out page might look:",
  Description:
    "Excepteur efficient emerging, minim veniam anim aute carefully curated Ginza conversation exquisite perfect nostrud nisi intricate Content. Qui  international first-class nulla ut. Punctual adipisicing, essential lovely queen tempor eiusmod irure. Exclusive izakaya charming Scandinavian impeccable aute quality of life soft power pariatur Melbourne occaecat discerning. Qui wardrobe aliquip, et Porter destination Toto remarkable officia Helsinki excepteur Basset hound. Zürich sleepy perfect consectetur.",
  ABOUT: "ABOUT",
  SIGNUP: "SIGNUP",
  LOGIN: "LOGIN",
  PRIVACY_POLICY: "PRIVACY POLICY",
  TERMS_OF_USE: "TERMS OF USE",
  CONTACT_US: "CONTACT US",
  Similar_Machines: "Similar Machines",
};

export const registeringForm = {
  THANKS_REGISTERING: "THANKS FOR REGISTERING",
  COMPLETE_REGISTRATION: "COMPLETE COMPANY REGISTRATION",
  LIST_YOUR_MACHINE: "LIST YOUR MACHINE",
  LIST_MY_MACHINE: "LIST MY MACHINE",
  MORE_FIELD: "More Fields",
  DRAG_AND_DROP: "Drag and Drop or click to Upload",
  CHOOSE_PRICING_TIER: "CHOOSE A PRICING TIER",
  SELECT_PLAN: "SELECT PLAN",
};

export const pricingListArray = [
  {
    title: "UNLIMITED",
    subTitle: "per Months",
    price: "$3000",
    list: [
      "Lorem Ipsum is a dummy text",
      "Lorem Ipsum is a dummy text",
      "Lorem Ipsum is a dummy text",
      "Lorem Ipsum is a dummy text",
      "Lorem Ipsum is a dummy text",
      "Lorem Ipsum is a dummy text",
      "Lorem Ipsum is a dummy text",
    ],
  },
  {
    title: "PROFESSIONAL",
    subTitle: "per Months",
    price: "$2000",
    list: [
      "Lorem Ipsum is a dummy text",
      "Lorem Ipsum is a dummy text",
      "Lorem Ipsum is a dummy text",
      "Lorem Ipsum is a dummy text",
      "Lorem Ipsum is a dummy text",
      "Lorem Ipsum is a dummy text",
      "Lorem Ipsum is a dummy text",
    ],
  },
  {
    title: "PLUS",
    subTitle: "per Months",
    price: "$1000",
    list: [
      "Lorem Ipsum is a dummy text",
      "Lorem Ipsum is a dummy text",
      "Lorem Ipsum is a dummy text",
      "Lorem Ipsum is a dummy text",
      "Lorem Ipsum is a dummy text",
      "Lorem Ipsum is a dummy text",
      "Lorem Ipsum is a dummy text",
    ],
  },
  {
    title: "SINGLE",
    subTitle: "per Months",
    price: "$500",
    list: [
      "Lorem Ipsum is a dummy text",
      "Lorem Ipsum is a dummy text",
      "Lorem Ipsum is a dummy text",
      "Lorem Ipsum is a dummy text",
      "Lorem Ipsum is a dummy text",
      "Lorem Ipsum is a dummy text",
      "Lorem Ipsum is a dummy text",
    ],
  },
];
